module.exports = __webpack_public_path__ + "img/van-orange.ba58e915.svg";